module.exports = __webpack_public_path__ + "img/icon-clock.10d9696b.svg";